import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';

import { Config, MW_APP_CONFIG, MwAppConfigService } from '../../../config';
import { MwAuthService } from '../auth.service';
import { MwUserService } from '../user.service';

@Injectable()
export class MwAuthGuard implements CanActivate {
  private isDebug = false;
  constructor(
    private readonly userService: MwUserService,
    private readonly configService: MwAppConfigService,
    private readonly authService: MwAuthService,
    @Inject(MW_APP_CONFIG) private config: Config
  ) {
    this.configService
      .getConfig()
      .pipe(take(1))
      .subscribe((config) => (this.isDebug = config.debug === true));
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const skipAuthRoutes = this.config.environment.skipAuthRoutes || [];
    if (skipAuthRoutes.some((skipRoute) => state.url.includes(skipRoute))) {
      return true;
    }

    let result = this.authService.loggedIn$.pipe(
      tap((isLoggedIn) => {
        if (!isLoggedIn) {
          this.authService.authorize(state.url);
        }
      }),
      switchMap(() => this.userService.userProfile$),
      map((profile) => !!profile)
    );

    result = result.pipe(
      tap((canAccess) => {
        this.log(
          `${canAccess ? 'Allow access page' : 'Page access restricted'}`
        );
      }),
      filter((canAccess) => canAccess)
    );

    return result;
  }

  private log(message: string): void {
    if (this.isDebug) {
      // tslint:disable-next-line:no-console
      console.debug(`MwAuthGuard: ${message}`);
    }
  }
}
